import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-content-start mb-3"
}
const _hoisted_2 = { class: "confirmation-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle mr-3",
  style: {"font-size":"2rem"}
}, null, -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "text-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_KoruActionButton = _resolveComponent("KoruActionButton")!
  const _component_Column = _resolveComponent("Column")!
  const _component_TreeTable = _resolveComponent("TreeTable")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.moduleRef.canCreate && _ctx.user.canCreate(_ctx.requiredModule))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _withDirectives(_createVNode(_component_Button, {
            icon: "pi pi-plus",
            severity: "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createAction(undefined)))
          }, null, 512), [
            [
              _directive_tooltip,
              _ctx.t('buttons.create'),
              void 0,
              { bottom: true }
            ]
          ]),
          _renderSlot(_ctx.$slots, "afterCreateButton")
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_TreeTable, {
      class: _normalizeClass(`p-datatable-${_ctx.moduleRef.suffix} ${_ctx.additionalClass}`),
      expandedKeys: _ctx.moduleRef.expandedKeys,
      "onUpdate:expandedKeys": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.moduleRef.expandedKeys) = $event)),
      responsiveLayout: "scroll",
      showGridlines: "",
      value: _ctx.nodes
    }, {
      empty: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t("gen.noData")), 1)
      ]),
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "columns"),
        (_ctx.moduleRef.canEdit || _ctx.moduleRef.canDelete || (_ctx.moduleRef.contextCommands !== undefined && _ctx.moduleRef.contextCommands.length > 0))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 0,
              headerStyle: "width: 10%",
              bodyClass: "text-center",
              header: _ctx.t('gen.actions')
            }, {
              body: _withCtx(({ node }) => [
                _createVNode(_component_KoruActionButton, {
                  model: _ctx.getContextCommands(node.data),
                  reference: node.data
                }, null, 8, ["model", "reference"])
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["class", "expandedKeys", "value"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showDeleteItemDialog,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showDeleteItemDialog) = $event)),
      style: { width: '450px' },
      header: _ctx.t('gen.deleteTitle'),
      modal: true,
      closable: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: _ctx.t('gen.no'),
          icon: "pi pi-times",
          class: "p-button-text",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDeleteItemDialog = false))
        }, null, 8, ["label"]),
        _createVNode(_component_Button, {
          label: _ctx.t('gen.yes'),
          icon: "pi pi-check",
          class: "p-button-text",
          onClick: _ctx.deleteItemAction
        }, null, 8, ["label", "onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(_ctx.t("gen.deleteConfirm")) + " ", 1),
            (_ctx.moduleRef.deleteDescriptionField == undefined)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.t("gen.deleteObject")), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.DataHelpers.getObjectValueByNestedKey(_ctx.deleteItem, _ctx.moduleRef.deleteDescriptionField)), 1),
                  _createTextVNode(" ? ")
                ]))
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ], 64))
}